// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB9DNCfLV5gKyrYgJMBvXpDQatvyoUvDRI",
  authDomain: "assignment12-79962.firebaseapp.com",
  projectId: "assignment12-79962",
  storageBucket: "assignment12-79962.appspot.com",
  messagingSenderId: "580089261943",
  appId: "1:580089261943:web:c8396251b8775524417b72"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app